var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemandeAide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Point_d_x27_interrogation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7,74c0-2.5-2.1-4-5-4c-2.4,0-4.5,1-6,2.8c-0.8,0.9-2,1.2-3,0.6l-4.1-2.4c-1.4-0.8-1.8-2.9-0.7-4.2 c3.2-4,8.2-6.6,15.1-6.6c8.8,0,15,4.1,15,11.8c0,8.7-7.4,10.8-9,15.2c-0.4,1.1-1.4,1.7-2.4,1.7h-5c-1.7,0-3-1.9-2.3-3.7 C77.1,80,82.7,77.9,82.7,74z M73.2,98.9c0-3.7,2.6-6.4,6.4-6.4c3.8,0,6.5,2.8,6.5,6.4c0,3.6-2.7,6.6-6.5,6.6 C75.9,105.5,73.2,102.5,73.2,98.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bulle_00000037662298444047267030000008134540913381287827_",
    className: "st0",
    d: "M80.3,26c-13.7,0-26.2,5.1-35.7,13.6 c-11,9.8-18,24.1-18,40.1v42.9c0,5.9,4.8,10.7,10.7,10.7h42.9c15.9,0,30.1-6.9,39.9-17.9c8.5-9.5,13.7-22,13.7-35.8 C133.9,50,109.9,26,80.3,26z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandeAide);
export default __webpack_public_path__ + "static/media/demande_aide.fd759f9717e816ecc18658c48d6864f9.svg";
export { ForwardRef as ReactComponent };